import useAuth0Metadata from "api/useAuth0Metadata"
import { useCustomerData } from "context/customer-provider"
import { useLocation } from "react-router-dom"
import { getRoutes } from "utils/routes"
import type { Route } from "types/not-yet-sorted"
import styles from "./AppBreadcrumb.module.scss"

// TODO: improve this component to do what we expect
const AppBreadcrumb = () => {
  const location = useLocation()
  const { pathname } = location

  const { customerId } = useCustomerData()
  const { userIsSuperAdmin } = useAuth0Metadata()
  const routes = getRoutes(customerId, userIsSuperAdmin)

  let name = pathname.replace("/", "")
  let currentRoute: Route | undefined

  if (routes) {
    currentRoute = routes.find(
      (route) =>
        route.path === pathname ||
        (route.meta.breadcrumb[0].regex && pathname.match(route.meta.breadcrumb[0].regex)),
    )
    name = currentRoute ? currentRoute.meta.breadcrumb[0].label : name
  }

  const helpUrl = currentRoute?.meta?.helpUrl

  return (
    <>
      <span className={styles.name}>{name}</span>
      {helpUrl && (
        <a
          href={helpUrl}
          target="_blank"
          rel="noopener noreferrer"
          title="View User Guide"
          aria-label={`View User Guide for ${name}`}
          className={styles.helpLink}
        >
          <i className={`pi pi-question-circle ${styles.helpIcon}`} aria-hidden="true" />
          <span className={styles.helpText}>User guide</span>
        </a>
      )}
    </>
  )
}

export default AppBreadcrumb
